  (function () {
    var root = document.getElementById('bs-customizer');
    if (!root) return;

    var data = window.BS_CUSTOMIZER_DATA;

    var state = {
      tab: 'frame',
      step: 1,
      frame: { finish: null, size: null, orientation: null },
      tray: { option: null },
      frameDetails: { bgColor: null, designStyle: null, designPreview: null, personalItem: null, personalItemNote: '', notes: '' },
      trayDetails: { bgColor: null, flakes: null, designStyle: null, designPreview: null, personalItem: null, personalItemNote: '', notes: '' }
    };

    var sharedLabels = {
      bgColor: { clear: 'Clear', black: 'Black', white: 'White', 'artists-choose': 'Let our artists choose' },
      designStyle: { full: 'Full of flowers', deconstructed: 'Deconstructed', cornered: 'Cornered' },
      designPreview: { yes: 'Yes', 'trust-designers': 'Trust our designers' },
      flakes: { none: 'No flakes', gold: 'Gold (+$10)', silver: 'Silver (+$10)', 'rose-gold': 'Rose gold (+$10)' }
    };

    var frameBgLabels = { black: 'Black', white: 'White', 'artists-choose': 'Let our artists choose' };

    var fmt = function (price) {
      return '$' + (Number(price) / 100).toFixed(2);
    };

    var tabs = root.querySelectorAll('.bs-cz-tab');
    var steps = root.querySelectorAll('.bs-cz-step');
    var panels = root.querySelectorAll('.bs-cz-panel');
    var backBtn = document.getElementById('bs-cz-back');
    var nextBtn = document.getElementById('bs-cz-next');
    var addToCartBtn = document.getElementById('bs-cz-add-to-cart');
    var mobileCartBtn = document.getElementById('bs-cz-mobile-cart');
    var mobileNoteEl = document.getElementById('bs-cz-mobile-note');
    var previewImage = document.getElementById('bs-cz-preview-image');
    var previewName = document.getElementById('bs-cz-preview-name');
    var previewPrice = document.getElementById('bs-cz-preview-price');
    var previewSpecs = document.getElementById('bs-cz-preview-specs');
    var reviewEl = document.getElementById('bs-cz-review');
    var messageEl = document.getElementById('bs-cz-message');
    var frameNotesInput = document.getElementById('bs-cz-frame-notes');
    var trayNotesInput = document.getElementById('bs-cz-tray-notes');
    var personalItemWrap = document.getElementById('bs-cz-personal-item-wrap');
    var personalItemNote = document.getElementById('bs-cz-personal-item-note');
    var trayPersonalItemWrap = document.getElementById('bs-cz-tray-personal-item-wrap');
    var trayPersonalItemNote = document.getElementById('bs-cz-tray-personal-item-note');

    function getSelection() {
      if (state.tab === 'frame') {
        if (!state.frame.finish || !state.frame.size || !state.frame.orientation) return null;
        var finish = data.frame.finishes[state.frame.finish];
        var sizeData = finish.sizes[state.frame.size];
        if (!sizeData) return null;
        var orientationLabel = state.frame.orientation === 'landscape' ? 'Landscape' : 'Portrait';
        return {
          variantId: sizeData.id,
          price: sizeData.price,
          image: finish.image,
          name: finish.name + ' Frame',
          specs: ['Finish: ' + finish.name, 'Size: ' + state.frame.size, 'Orientation: ' + orientationLabel]
        };
      } else {
        if (!state.tray.option) return null;
        var tray = data.tray.options[state.tray.option];
        return {
          variantId: tray.id,
          price: tray.price,
          image: tray.image,
          name: tray.name,
          specs: ['Style: ' + tray.name]
        };
      }
    }

    function switchTab(tab) {
      state.tab = tab;
      state.step = 1;
      clearErrors();
      tabs.forEach(function (btn) {
        var active = btn.getAttribute('data-tab') === tab;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      render();
    }

    function setStep(step) {
      state.step = step;
      clearErrors();
      render();
    }

    function render() {
      // Panels
      panels.forEach(function (panel) {
        var panelStep = parseInt(panel.getAttribute('data-panel'), 10);
        var panelTab = panel.getAttribute('data-tab-panel');
        var matches = panelStep === state.step && (!panelTab || panelTab === state.tab);
        panel.classList.toggle('is-active', matches);
      });

      // Step indicator
      steps.forEach(function (stepEl) {
        var stepNum = parseInt(stepEl.getAttribute('data-step'), 10);
        stepEl.classList.toggle('is-active', stepNum === state.step);
        stepEl.classList.toggle('is-complete', stepNum < state.step);
      });

      // Nav buttons
      backBtn.disabled = state.step === 1;
      if (state.step === 3) {
        nextBtn.style.display = 'none';
        nextBtn.hidden = true;
      } else {
        nextBtn.style.display = '';
        nextBtn.hidden = false;
        nextBtn.textContent = state.step === 1 ? 'Next: Details' : 'Next: Review';
      }

      var selection = getSelection();

      // Update preview image as soon as a finish or tray is chosen
      if (state.tab === 'frame' && state.frame.finish) {
        var fin = data.frame.finishes[state.frame.finish];
        previewImage.src = fin.image;
        previewImage.alt = fin.name + ' Frame';
      } else if (state.tab === 'tray' && state.tray.option) {
        var trayOpt = data.tray.options[state.tray.option];
        previewImage.src = trayOpt.image;
        previewImage.alt = trayOpt.name;
      }

      // Sidebar preview
      if (selection) {
        previewName.textContent = selection.name;
        previewPrice.textContent = fmt(selection.price);
        previewSpecs.innerHTML = '';
        selection.specs.forEach(function (spec) {
          var li = document.createElement('li');
          li.textContent = spec;
          previewSpecs.appendChild(li);
        });
        if (state.tab === 'frame') {
          if (state.frameDetails.bgColor) {
            var li1 = document.createElement('li');
            li1.textContent = 'Background: ' + (frameBgLabels[state.frameDetails.bgColor] || state.frameDetails.bgColor);
            previewSpecs.appendChild(li1);
          }
          if (state.frameDetails.designStyle) {
            var li2 = document.createElement('li');
            li2.textContent = 'Style: ' + sharedLabels.designStyle[state.frameDetails.designStyle];
            previewSpecs.appendChild(li2);
          }
        } else {
          if (state.trayDetails.bgColor) {
            var li3 = document.createElement('li');
            li3.textContent = 'Background: ' + (sharedLabels.bgColor[state.trayDetails.bgColor] || state.trayDetails.bgColor);
            previewSpecs.appendChild(li3);
          }
          if (state.trayDetails.flakes && state.trayDetails.flakes !== 'none') {
            var liFlakes = document.createElement('li');
            liFlakes.textContent = 'Flakes: ' + sharedLabels.flakes[state.trayDetails.flakes];
            previewSpecs.appendChild(liFlakes);
          }
          if (state.trayDetails.designStyle) {
            var li4 = document.createElement('li');
            li4.textContent = 'Style: ' + sharedLabels.designStyle[state.trayDetails.designStyle];
            previewSpecs.appendChild(li4);
          }
        }
      } else {
        previewName.textContent = state.tab === 'frame' ? 'Select a finish & size' : 'Select a tray';
        previewPrice.textContent = '--';
        previewSpecs.innerHTML = '';
      }

      addToCartBtn.disabled = !(selection && state.step === 3);

      // Mobile step-3 controls
      var isMobile = window.innerWidth < 990;
      if (mobileCartBtn) {
        var showMobileCart = state.step === 3 && isMobile;
        mobileCartBtn.style.display = showMobileCart ? '' : 'none';
        mobileCartBtn.hidden = !showMobileCart;
        mobileCartBtn.disabled = !(selection && state.step === 3);
      }
      if (mobileNoteEl) {
        mobileNoteEl.style.display = (state.step === 3 && isMobile) ? '' : 'none';
      }

      // Review panel
      if (state.step === 3) {
        if (selection) {
          var rows = '';
          selection.specs.forEach(function (spec) {
            var parts = spec.split(': ');
            rows += '<dt>' + parts[0] + '</dt><dd>' + parts[1] + '</dd>';
          });
          var totalPrice = selection.price;
          if (state.tab === 'tray' && state.trayDetails.flakes && state.trayDetails.flakes !== 'none') {
            totalPrice += 1000;
          }
          rows += '<dt>Price</dt><dd>' + fmt(totalPrice) + '</dd>';
          if (state.tab === 'frame') {
            if (state.frameDetails.bgColor) rows += '<dt>Background Color</dt><dd>' + (frameBgLabels[state.frameDetails.bgColor] || state.frameDetails.bgColor) + '</dd>';
            if (state.frameDetails.designStyle) rows += '<dt>Design Style</dt><dd>' + sharedLabels.designStyle[state.frameDetails.designStyle] + '</dd>';
            if (state.frameDetails.designPreview) rows += '<dt>Design Preview</dt><dd>' + sharedLabels.designPreview[state.frameDetails.designPreview] + '</dd>';
            if (state.frameDetails.personalItem === 'yes') rows += '<dt>Personal Item</dt><dd>' + (state.frameDetails.personalItemNote || 'Yes') + '</dd>';
            if (state.frameDetails.notes) rows += '<dt>Special Instructions</dt><dd>' + state.frameDetails.notes + '</dd>';
          } else {
            if (state.trayDetails.bgColor) rows += '<dt>Background Color</dt><dd>' + (sharedLabels.bgColor[state.trayDetails.bgColor] || state.trayDetails.bgColor) + '</dd>';
            if (state.trayDetails.flakes) rows += '<dt>Flakes</dt><dd>' + sharedLabels.flakes[state.trayDetails.flakes] + '</dd>';
            if (state.trayDetails.designStyle) rows += '<dt>Design Style</dt><dd>' + sharedLabels.designStyle[state.trayDetails.designStyle] + '</dd>';
            if (state.trayDetails.designPreview) rows += '<dt>Design Preview</dt><dd>' + sharedLabels.designPreview[state.trayDetails.designPreview] + '</dd>';
            if (state.trayDetails.personalItem === 'yes') rows += '<dt>Personal Item</dt><dd>' + (state.trayDetails.personalItemNote || 'Yes') + '</dd>';
            if (state.trayDetails.notes) rows += '<dt>Special Instructions</dt><dd>' + state.trayDetails.notes + '</dd>';
          }
          reviewEl.innerHTML = '<dl>' + rows + '</dl>';
        } else {
          reviewEl.innerHTML = '<p>Please complete the design step first.</p>';
        }
      }
    }

    // Tab clicks
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchTab(btn.getAttribute('data-tab'));
      });
    });

    // Option group clicks
    root.querySelectorAll('[data-group]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('button[data-value]');
        if (!btn) return;
        var groupName = group.getAttribute('data-group');
        var value = btn.getAttribute('data-value');

        group.querySelectorAll('button[data-value]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        // Clear field-level error when user makes a selection
        var fieldEl = group.closest('.bs-cz-field');
        if (fieldEl) fieldEl.classList.remove('has-error');

        // Frame groups
        if (groupName === 'finish') state.frame.finish = value;
        if (groupName === 'size') state.frame.size = value;
        if (groupName === 'orientation') state.frame.orientation = value;
        if (groupName === 'bg-color') state.frameDetails.bgColor = value;
        if (groupName === 'frame-style') state.frameDetails.designStyle = value;
        if (groupName === 'design-preview') state.frameDetails.designPreview = value;
        if (groupName === 'personal-item') {
          state.frameDetails.personalItem = value;
          if (personalItemWrap) personalItemWrap.style.display = value === 'yes' ? 'block' : 'none';
        }

        // Tray groups
        if (groupName === 'tray') state.tray.option = value;
        if (groupName === 'tray-bg-color') state.trayDetails.bgColor = value;
        if (groupName === 'tray-flakes') state.trayDetails.flakes = value;
        if (groupName === 'tray-style') state.trayDetails.designStyle = value;
        if (groupName === 'tray-preview') state.trayDetails.designPreview = value;
        if (groupName === 'tray-personal-item') {
          state.trayDetails.personalItem = value;
          if (trayPersonalItemWrap) trayPersonalItemWrap.style.display = value === 'yes' ? 'block' : 'none';
        }

        render();
      });
    });

    if (frameNotesInput) {
      frameNotesInput.addEventListener('input', function () {
        state.frameDetails.notes = frameNotesInput.value;
        if (state.step === 3) render();
      });
    }

    if (trayNotesInput) {
      trayNotesInput.addEventListener('input', function () {
        state.trayDetails.notes = trayNotesInput.value;
        if (state.step === 3) render();
      });
    }

    if (personalItemNote) {
      personalItemNote.addEventListener('input', function () {
        state.frameDetails.personalItemNote = personalItemNote.value;
      });
    }

    if (trayPersonalItemNote) {
      trayPersonalItemNote.addEventListener('input', function () {
        state.trayDetails.personalItemNote = trayPersonalItemNote.value;
      });
    }

    backBtn.addEventListener('click', function () {
      if (state.step > 1) setStep(state.step - 1);
    });

    if (mobileCartBtn) {
      mobileCartBtn.addEventListener('click', function () {
        addToCartBtn.click();
      });
    }

    nextBtn.addEventListener('click', function () {
      if (state.step === 1 && !getSelection()) {
        showMessage('error', state.tab === 'frame' ? 'Please choose a finish, size, and orientation to continue.' : 'Please choose a tray to continue.');
        return;
      }
      if (state.step === 2 && !validateStep2()) return;
      if (state.step < 3) setStep(state.step + 1);
    });

    function showMessage(type, text) {
      messageEl.hidden = false;
      messageEl.textContent = text;
      messageEl.classList.remove('is-success', 'is-error');
      messageEl.classList.add(type === 'success' ? 'is-success' : 'is-error');
    }

    function clearErrors() {
      root.querySelectorAll('.bs-cz-field.has-error').forEach(function (el) {
        el.classList.remove('has-error');
      });
    }

    function validateStep2() {
      clearErrors();
      var fields = state.tab === 'frame'
        ? [
            { val: state.frameDetails.bgColor, group: 'bg-color' },
            { val: state.frameDetails.designStyle, group: 'frame-style' },
            { val: state.frameDetails.designPreview, group: 'design-preview' },
            { val: state.frameDetails.personalItem, group: 'personal-item' }
          ]
        : [
            { val: state.trayDetails.bgColor, group: 'tray-bg-color' },
            { val: state.trayDetails.flakes, group: 'tray-flakes' },
            { val: state.trayDetails.designStyle, group: 'tray-style' },
            { val: state.trayDetails.designPreview, group: 'tray-preview' },
            { val: state.trayDetails.personalItem, group: 'tray-personal-item' }
          ];

      var firstError = null;
      var hasErrors = false;
      fields.forEach(function (f) {
        if (!f.val) {
          hasErrors = true;
          var groupEl = root.querySelector('[data-group="' + f.group + '"]');
          var fieldEl = groupEl ? groupEl.closest('.bs-cz-field') : null;
          if (fieldEl) {
            fieldEl.classList.add('has-error');
            if (!firstError) firstError = fieldEl;
          }
        }
      });

      if (hasErrors) {
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        showMessage('error', 'Please make all required selections before continuing.');
        return false;
      }
      return true;
    }

    addToCartBtn.addEventListener('click', function () {
      var selection = getSelection();
      if (!selection) return;

      var properties = {};
      selection.specs.forEach(function (spec) {
        var parts = spec.split(': ');
        properties[parts[0]] = parts[1];
      });
      if (state.tab === 'frame') {
        if (state.frameDetails.bgColor) properties['Background Color'] = frameBgLabels[state.frameDetails.bgColor] || state.frameDetails.bgColor;
        if (state.frameDetails.designStyle) properties['Design Style'] = sharedLabels.designStyle[state.frameDetails.designStyle];
        if (state.frameDetails.designPreview) properties['Design Preview'] = sharedLabels.designPreview[state.frameDetails.designPreview];
        if (state.frameDetails.personalItem === 'yes') properties['Personal Item'] = state.frameDetails.personalItemNote || 'Yes';
        if (state.frameDetails.notes) properties['Special Instructions'] = state.frameDetails.notes;
      } else {
        if (state.trayDetails.bgColor) properties['Background Color'] = sharedLabels.bgColor[state.trayDetails.bgColor] || state.trayDetails.bgColor;
        if (state.trayDetails.flakes) properties['Flakes'] = sharedLabels.flakes[state.trayDetails.flakes];
        if (state.trayDetails.designStyle) properties['Design Style'] = sharedLabels.designStyle[state.trayDetails.designStyle];
        if (state.trayDetails.designPreview) properties['Design Preview'] = sharedLabels.designPreview[state.trayDetails.designPreview];
        if (state.trayDetails.personalItem === 'yes') properties['Personal Item'] = state.trayDetails.personalItemNote || 'Yes';
        if (state.trayDetails.notes) properties['Special Instructions'] = state.trayDetails.notes;
      }

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: selection.variantId, quantity: 1, properties: properties }]
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
          if (json.status) {
            showMessage('error', json.description || 'Something went wrong adding this to your cart.');
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          window.location.href = '/cart';
        })
        .catch(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to Cart';
          showMessage('error', 'Something went wrong adding this to your cart.');
        });
    });

    render();
  })();
